function Topics() {
  return (
    <div>
      <h1>heyyyy !</h1>
    </div>
  );
}

export default Topics;
